import { createSlice } from '@reduxjs/toolkit';

import { getFabrics, createFabric, createSkuMaterial, getVendors } from '../../apis';
import { createPurchaseOrder, createSkuFabricMaterial, deletePurchaseOrder, getVendorPurchaseOrders, getVendorsList, getWarehouseShelves, modifyFabric, updatePurchaseOrder } from './api';

export const InventoryManagementSlice = createSlice({

    name: 'inventoryManagementSlice',
    initialState: {
        isLoading: false,
        fabricsData: {},
        vendorPurchaseData: [],
        vendorData: [],
        tabsData: [],
        createFabricSuccess: false,
        modifyFabricSuccess: false,
        createPurchaseOrderSuccess: false,
        updatePurchaseOrderSuccess: false,
        deletePurchaseOrderSuccess: false,
        warehouseShelfData: [],
        fabricVendorList: [],
        error: ''
    },

    reducers: {
      clear: (state, action) => {
        if(action?.payload?.key) {
          return {
            ...state,
            [action.payload.key]: action.payload.value
          }
        }
        return { ...state }
      },
      clearErrorState: (state, action) => {
        return {
          ...state,
          error: action.payload
        }
        },
        clearVendorPurchaseData: (state, action) => {
            state.vendorPurchaseData = action.payload;
      }
    },

    extraReducers: (builder) => {
      builder.addCase(getFabrics.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(getFabrics.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.fabricsData = action.payload.data;
          state.tabsData = action.payload.data?.quantity_map;
      })
      builder.addCase(getFabrics.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      
      builder.addCase(createSkuFabricMaterial.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(createSkuFabricMaterial.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.createFabricSuccess = true
      })
      builder.addCase(createSkuFabricMaterial.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(modifyFabric.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(modifyFabric.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.modifyFabricSuccess = true
      })
      builder.addCase(modifyFabric.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(getVendorPurchaseOrders.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(getVendorPurchaseOrders.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.vendorPurchaseData = action.payload.data?.data;
          state.tabsData = action.payload.data?.quantity_map;
      })
      builder.addCase(getVendorPurchaseOrders.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(createPurchaseOrder.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(createPurchaseOrder.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.createPurchaseOrderSuccess = true
      })
      builder.addCase(createPurchaseOrder.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      
      builder.addCase(getVendors.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(getVendors.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.vendorData = action.payload.data
      })
      builder.addCase(getVendors.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(updatePurchaseOrder.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(updatePurchaseOrder.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.updatePurchaseOrderSuccess = true
      })
      builder.addCase(updatePurchaseOrder.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(deletePurchaseOrder.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(deletePurchaseOrder.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.deletePurchaseOrderSuccess = true
      })
      builder.addCase(deletePurchaseOrder.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(getWarehouseShelves.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(getWarehouseShelves.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.warehouseShelfData = action.payload.data
      })
      builder.addCase(getWarehouseShelves.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(getVendorsList.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(getVendorsList.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.fabricVendorList = action.payload.data
      })
      builder.addCase(getVendorsList.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
    }
})

export const { clearGatePassDetailsData, clearErrorState, clear, clearVendorPurchaseData } = InventoryManagementSlice.actions


export default InventoryManagementSlice.reducer